import { useState } from "react";

/**
 * タスク一覧のセクションの開閉。既定は初回描画で一度だけ決め、以降はユーザーの操作だけが変える。
 * 既定を毎描画で計算し直すと、2 秒ごとのポーリングで最後の run が終わった瞬間にセクションが
 * 自分で畳まれ、結果を最も見たいところでカードが消える。
 *
 * 例外は「今ここを見せないと困る」ことが起きた瞬間で、そのときだけ強制的に開く。
 * - selectedHere が別の run に変わった (選択が入ってきた / セクション内で移った) — 畳んだままだと
 *   右に詳細を出している run が一覧から見えなくなる。
 * - hasActive が立った — 実行中の run はどこにも出ていない状態を作らない。
 * どちらも「変わった瞬間」だけを見るので、無関係な run のクリックでは閉じず、選択中の run が
 * 居るセクションも実行中のセクションも手で畳める。
 * state の調整は描画中に行う (effect だと切替直後の 1 フレームだけ前の値が残る)。
 */
export function useSectionCollapse(
	defaultCollapsed: boolean,
	/** このセクションに居る選択中の run の id。選択が他所にあるなら null。 */
	selectedHere: string | null,
	hasActive = false,
): [collapsed: boolean, toggle: () => void] {
	const [collapsed, setCollapsed] = useState(defaultCollapsed);
	const [seen, setSeen] = useState({ selectedHere, hasActive });
	if (seen.selectedHere !== selectedHere || seen.hasActive !== hasActive) {
		setSeen({ selectedHere, hasActive });
		if (
			(selectedHere !== null && selectedHere !== seen.selectedHere) ||
			(hasActive && !seen.hasActive)
		)
			setCollapsed(false);
	}
	return [collapsed, () => setCollapsed((current) => !current)];
}
